/**
 * File: common.js.
 *
 * Import and initialize functions that are common to all pages
 */

import formToolkit from "../components/form-toolkit";
import imageCarousel from "../components/image-carousel";
import pressMasonry from "../components/press-masonry";
import accessibilityZoom from "../components/accessibility-zoom";
import searchButton from "../components/search-button";
import ariaList from "../components/aria-list";
import testimonials from "../components/testimonials";
import ariaBurgerMenu from "../components/aria-burger-menu";
import ariaToTop from "../components/aria-to-top";
import ariaSearch from "../components/aria-search";
import ariaSearchPagination from "../components/aria-search-pagination";
import forceContent from "../components/force-content";
import navLandmarks from "../components/nav-landmarks";
import customBullets from "../components/custom-bullets";
import headingTitle from "../components/heading-title";
import ariaRegisterToVote from "../components/aria-register-to-vote";
import ariaGetInTouch from "../components/aria-get-in-touch";
import ariaLinks from "../components/aria-links";
import ariaAccordion from "../components/aria-accordion";
import imageTextHero from "../components/image-text-hero";
import focusTrap from "../components/focus-trap";
import upcomingEvents from "../components/upcoming-events";

export default {
	init() {
		this.render();
	},
	render() {
		formToolkit.init();
		accessibilityZoom.init();
		pressMasonry.init();
		imageCarousel.init();
		searchButton.init();
		ariaList.init();
		testimonials.init();
		ariaBurgerMenu.init();
		ariaToTop.init();
		ariaSearch.init();
		ariaSearchPagination.init();
		forceContent.init();
		navLandmarks.init();
		customBullets.init();
		headingTitle.init();
		ariaRegisterToVote.init();
		ariaGetInTouch.init();
		ariaLinks.init();
		ariaAccordion.init();
		imageTextHero.init();
		focusTrap.init();
		upcomingEvents.init();
		// global
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
